var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.termsConditions)?_c(_vm.modules.TermsConditions,_vm._b({tag:"component"},'component',_vm.termsConditions,false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }